module.exports = __webpack_public_path__ + "media/game-video.95b83a3f.mp4";